export default interface KYCDetails {
    username: string;
    pan: string;
    aadhar_number: string;
    permanent_address: string;
    status: string;
    comment?: string;
    created_date: string;
    created_by: string;
    updated_date: string;
    updated_by: string;
};

export enum KYCDetailsStatus {
    PENDING_REVIEW = "PENDING_REVIEW",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
};